import createCache from '@emotion/cache'

// Style order in <head> as v4 had it: page stylesheets (e.g. Material Icons), then MUI's own styles,
// then the app's makeStyles rules. App rules therefore win equal-specificity ties against MUI
// (e.g. `.row > *` over Typography's `gutterBottom`), and MUI's against `.material-icons`.
// With one shared cache the winner would depend on render order.
const insertionPoint = document.createElement('meta')
insertionPoint.name = 'mui-insertion-point'
document.head.appendChild(insertionPoint)

export const muiCache = createCache({ key: 'mui', insertionPoint })
export const tssCache = createCache({ key: 'tss' })
